module.exports = "/images/vendor/desiigner-svg/svg/social/amazon_music.svg?2ef297c7977ea2dcdb8aa1caf3ba7dde";